var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter0_f_8645_105386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 10C23.4526 10 10 23.4526 10 40C10 56.5474 23.4526 70 40 70C56.5474 70 70 56.5474 70 40C70 23.4526 56.5474 10 40 10ZM50.8632 41.7684L34.6947 52.5053C33.3053 53.4526 31.4737 52.4421 31.4737 50.7368V29.2C31.4737 27.5579 33.3053 26.5474 34.6947 27.4316L50.8632 38.2316C52.1263 39.1158 52.1263 40.8842 50.8632 41.7684Z",
    fill: "url(#paint0_linear_8645_105386)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8645_105386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 8C23.4526 8 10 21.4526 10 38C10 54.5474 23.4526 68 40 68C56.5474 68 70 54.5474 70 38C70 21.4526 56.5474 8 40 8ZM50.8632 39.7684L34.6947 50.5053C33.3053 51.4526 31.4737 50.4421 31.4737 48.7368V27.2C31.4737 25.5579 33.3053 24.5474 34.6947 25.4316L50.8632 36.2316C52.1263 37.1158 52.1263 38.8842 50.8632 39.7684Z",
    fill: "url(#paint1_linear_8645_105386)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1398 40.1849L51.1398 40.1851L51.1499 40.178C52.6974 39.0948 52.6974 36.9052 51.1499 35.822L51.15 35.8219L51.1409 35.8158L34.9725 25.0158L34.9725 25.0157L34.9632 25.0097C33.2399 23.9131 30.9737 25.1645 30.9737 27.2V48.7368C30.9737 50.8188 33.233 52.104 34.9736 50.9203C34.9745 50.9197 34.9755 50.919 34.9764 50.9184L51.1398 40.1849ZM10.5 38C10.5 21.7288 23.7288 8.5 40 8.5C56.2712 8.5 69.5 21.7288 69.5 38C69.5 54.2712 56.2712 67.5 40 67.5C23.7288 67.5 10.5 54.2712 10.5 38Z",
    stroke: "url(#paint2_radial_8645_105386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8645_105386",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_8645_105386"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8645_105386",
    x: 10,
    y: 4,
    width: 60,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.84 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8645_105386"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8645_105386",
    x1: 48.7363,
    y1: 14.1585,
    x2: 35.4061,
    y2: 62.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8645_105386",
    x1: 48.7363,
    y1: 12.1585,
    x2: 35.4061,
    y2: 60.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C610"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8645_105386",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10 68) rotate(-45) scale(63.0421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17255,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.749ed17dc341a0717ab494acb2130593.svg";
export { ForwardRef as ReactComponent };